








































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import vuedraggable from "vuedraggable";
import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import { Utils } from "@/services/utils";
import { CommonService } from "@/services/Common.service";
import { FeeService } from "@/services/fee.service";
import InputNumber from "@/views/components/input/InputNumber.vue";
  // 2022-01-31 morisako kobac-free add [START]
import { ShatenService } from "@/services/shaten.service";
  // 2022-01-31 morisako kobac-free add [END]

@Component({
  components: {
    draggable: vuedraggable,
    InputNumber
  },
  mixins: [FilterSelectBox],
})
export default class FeeTable extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;

  util = new Utils();
  commonService = new CommonService();
  feeService = new FeeService();
  versionDataList: any = [];
  isNotAdmin = true;
  feeList: any = [];
  sknInspectSeibiFeeNm = "";
  showConfirmDelete = false;
  idDelete: any = null;
  idEdit = -1;
  itemEdit: any = {};
  timerReOrder: any = null;

  fmBlIsUseDiscount: boolean = false;
  fmIsUseDiscount: any = 0;
  fmDiscountRate: any = 0;
  // 2022-01-31 morisako kobac-free add [START]
  fmBlIsBuhinUseDiscount: boolean = false;
  fmBuhinIsUseDiscount: any = 0;
  fmBuhinDiscountRate: any = 0;
  seibiMenuFeeList: any = [];
  shatenService: ShatenService = new ShatenService();
  // 2022-01-31 morisako kobac-free add [END]

  created() {
    this.form = {
      kyotenCd: "",
      groupCd: "",
      shatenCd: "",
      version: "",
    };
    const loginTypeKbn = localStorage.getItem("loginTypeKbn");
    if (loginTypeKbn === "1" || loginTypeKbn === "10") {
      this.isNotAdmin = false;
    }
    this.getGroupDataList().then((res) => {
      this.getShatenDataList(false).then((res2) => {
        this.$set(this, "shatenDataList", this.util.deepCopy(res2));
        this.getKyotenDataList(false, true).then((res3) => {
          if (res3 && res3.length > 0) {
            this.kyotenDataList = res3;
            this.form.kyotenCd = localStorage.getItem("kyotenCd");
            this.getVersionList(true);
          }
        });
      });
    });
  }

  async selectGroup1() {
    if (this.form.groupCd) {
      this.versionDataList = [];
      // 2022-01-31 morisako kobac-free mod [START]
      // this.selectGroup();
      this.form.shatenCd = null;
      this.form.kyotenCd = "";
      this.kyotenDataList = [];
      this.form.version = "";
      this.shatenDataList = [];
      this.seibiMenuFeeList = [];
      this.getShatens().then(res2 => {
        if (res2 && res2.length > 0) {
          this.$set(this.form, "shatenCd", res2[0].shatenCd);
          this.getKyotenDataList().then(res3 => {
            if (res3) {
              if (res3.length == 0) {
                this.form.kyotenCd = "";
              } else {
                this.form.kyotenCd = localStorage.getItem("kyotenCd");
              }
              this.getVersionList().then(() => {
                if (this.versionDataList.length === 1) {
                  this.form.version = this.versionDataList[0].sknHanyouSeibiVersionId;
                }
                this.getFeeList();
              });
            }
          });
        }
      });
      // 2022-01-31 morisako kobac-free mod [END]
    } else {
      this.clearList("kyoten");
      this.clearList("version");
      this.form.shatenCd = null;
      this.form.kyotenCd = "";
      this.form.version = "";
      this.shatenDataList = [];
    }
  }

  async getVersionList(isInit: boolean = false) {
    let param = null;
    param = this.form;
    const key = "versionDataList";

    if (param.groupCd && param.shatenCd) {
      const response = await this.commonService.getHanyouSeibiVersion(
        param.groupCd,
        param.shatenCd,
        param.kyotenCd
      );
      this.$set(this, key, response);
    }
    if (this.versionDataList.length === 1) {
      this.$set(
        this.form,
        "version",
        this.versionDataList[0].sknHanyouSeibiVersionId
      );
      this.getFeeList();
    } else if (this.versionDataList.length === 0) {
      this.$set(this, "feeList", []);
    }
    return this[key];
  }

  selectKyoten(applyToAdd: boolean = true) {
    this.getVersionList(!applyToAdd);
  }

  selectVersion() {
    this.getFeeList();
  }

  async getFeeList() {
    const feeList = await this.feeService.getFeeTable(this.form.version);
    this.feeList = feeList.map(
      (e: any) => {
        const newObj = { ...e };
        newObj.blIsUseDiscount = e.isUseDiscount === 1 ? true : false;
        // 2022-01-31 morisako kobac-free add [START]
        newObj.blIsBuhinUseDiscount = e.buhinIsUseDiscount === 1 ? true : false;
        // 2022-01-31 morisako kobac-free add [END]
        return newObj;
      }
    );
    // 2022-01-31 morisako kobac-free add [START]
    this.getSeibiMenuInspectFee();
    // 2022-01-31 morisako kobac-free add [END]
  }

  clearList(key: string, applyToAdd: boolean = true) {
    let key1 = applyToAdd
      ? `${key}DataList`
      : `filter${this.util.capitalize(key)}DataList`;
    this.$set(this, key1, "");
  }

  async getShatenDataList(applyToAdd: boolean = true) {
    let param = null;
    param = this.form;
    const key = "shatenDataList";
    if (param.groupCd) {
      const response = await this.accountService.getShatens(param.groupCd);
      param.kyotenCd = "";
      param.version = "";
      this.clearList("kyoten", applyToAdd);
      this.clearList("version", applyToAdd);
      if (response) {
        this.$set(this, key, response);
      } else {
        this.$set(this, key, []);
      }
    }
    return this[key];
  }

  async getKyotenDataList(applyToAdd: boolean = true, isInit: boolean = false) {
    let param = null;
    param = this.form;
    if (param.groupCd && param.shatenCd) {
      param.kyotenCd = "";
      param.version = "";
      this.clearList("version", applyToAdd);
      const response = await this.commonService.getKyotenHasVersion(
        param.groupCd,
        param.shatenCd
      );

      const key = "kyotenDataList";
      if (response) {
        this.$set(this, key, response);
      } else {
        this.$set(this, key, []);
      }
      if (this[key].length === 0) {
        this.form.kyotenCd = "";
        this.getVersionList(isInit);
      }

      return response;
    }
    return [];
  }

  onEnd() {
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    this.timerReOrder = setTimeout(() => {
      this.feeList = this.feeList.map((e: any, i: number) => {
        return { ...e, displayOrder: i + 1 };
      });
      this.feeService.updateFeeOrder(this.feeList).then((res) => {
        if (res !== 200) {
          this.$message.error("エラー");
        }
      });
    }, 1500);
  }

  onEdit(row: any) {
    this.idEdit = row.sknInspectSeibiFeeId;
    this.itemEdit = { ...row };
  }

  async updateFeeItem() {
    delete this.itemEdit.blIsUseDiscount;
  // 2022-01-31 morisako kobac-free add [START]
    delete this.itemEdit.blIsBuhinUseDiscount;
  // 2022-01-31 morisako kobac-free add [END]
    const res = await this.feeService.updateFee(this.itemEdit);
    this.getDataAfterUpdate(res);
    this.onCancelEdit();
  }

  onCancelEdit() {
    this.idEdit = -1;
    this.itemEdit = {};
  }

  onClear() {
    this.sknInspectSeibiFeeNm = "";
    this.fmDiscountRate = 0;
    this.fmBlIsUseDiscount = false;
    this.fmIsUseDiscount = 0;
    // 2022-01-31 morisako kobac-free add [START]
    this.fmBuhinDiscountRate = 0;
    this.fmBlIsBuhinUseDiscount = false;
    this.fmBuhinIsUseDiscount = 0;
    // 2022-01-31 morisako kobac-free add [END]
  }

  getDataAfterUpdate(res: any) {
    if (res === 200) {
      this.getFeeList();
    } else {
      this.$message.error("エラー");
    }
  }

  async onAdd() {
    if (this.form.version && this.sknInspectSeibiFeeNm) {
      const res = await this.feeService.addFee(this.form.version, {
        sknInspectSeibiFeeNm: this.sknInspectSeibiFeeNm,
        isUseDiscount: this.fmIsUseDiscount,
        discountRate: this.fmDiscountRate
        // 2022-01-31 morisako kobac-free add [START]
        , buhinDiscountRate: this.fmBuhinDiscountRate
        , buhinIsUseDiscount: this.fmBuhinIsUseDiscount
        // 2022-01-31 morisako kobac-free add [END]
      });
      this.onClear();
      this.getDataAfterUpdate(res);
    }
  }

  onConfirmDelete(row: any) {
    this.showConfirmDelete = true;
    this.idDelete = row.sknInspectSeibiFeeId;
  }

  async onDelete() {
    this.showConfirmDelete = false;
    const res = await this.feeService.deleteFee(this.idDelete);
    this.getDataAfterUpdate(res);
  }

  onChangeIsUseDiscount(fee: any) {
    fee.isUseDiscount = fee.blIsUseDiscount ? 1 : 0;
  }

  onChangeFmIsUseDiscount() {
    this.fmIsUseDiscount = this.fmBlIsUseDiscount ? 1 : 0;
  }

  get fmAddBtnDisabled() {
    let isOK: boolean = true;

    if (!this.form) {
      isOK = false;
    }

    if (!this.form.groupCd || !this.form.shatenCd || !this.sknInspectSeibiFeeNm) {
      isOK = false;
    }

    return !isOK;
  }

  // 2022-01-31 morisako kobac-free add [START]
  onChangeIsBuhinUseDiscount(fee: any) {
    fee.buhinIsUseDiscount = fee.blIsBuhinUseDiscount ? 1 : 0;
  }

  onChangeFmBuhinIsUseDiscount() {
    this.fmBuhinIsUseDiscount = this.fmBlIsBuhinUseDiscount ? 1 : 0;
  }
  async getSeibiMenuInspectFee() {
    const data = await this.shatenService.getSeibiMenuInspectFeeMap(this.form.version);
    this.seibiMenuFeeList = data.filter((e: any) => e.seibiMenuCd);
  }
  async onChangeSeibiInspectFee(item: any) {
    let data= [item];
    const status = await this.shatenService.saveSeibiMenuInspectFeeMap(data);
    this.$set(this, "loadingSeibiMenu", false);
    if (status === 200) {
    } else {
      this.$message.error("エラー");
    }
  }
  public async getShatens() {
    if (this.form.groupCd) {
      const response = await this.accountService.getShatens(
        this.form.groupCd
      );
      if (response) {
        this.$set(this, "shatenDataList", response);
      } else {
        this.$set(this, "shatenDataList", []);
      }
      return response;
    }
  }
  selectShaten1() {
    this.getKyotenDataList().then(res3 => {
      if (res3) {
        if (res3.length == 0) {
          this.form.kyotenCd = "";
        } else {
          this.form.kyotenCd = localStorage.getItem("kyotenCd");
        }
        this.getVersionList().then(() => {
          if (this.versionDataList.length === 1) {
            this.form.version = this.versionDataList[0].sknHanyouSeibiVersionId;
          }
          this.getFeeList();
        });
      }
    });
  }
  // 2022-01-31 morisako kobac-free add [END]
}
